<div id="title">
  {{ title }}
</div>
<ionic-selectable
  [items]="coordinators$ | async"
  [(ngModel)]="selectedUser"
  [canSearch]="true"
  [canClear]="true"
  itemValueField="id"
  itemTextField="fullname"
  (onChange)="changed.emit($event.value)"
  [shouldFocusSearchbar]="true"
></ionic-selectable>
